import { generateMnemonic, mnemonicToSeed } from '@scure/bip39';
import { wordlist } from '@scure/bip39/wordlists/english';
import { HDKey } from '@scure/bip32';
import { getRootNode } from './models/common';
import { encrypt } from './encryption';
import { deriveAccount, deriveWalletKeys } from './derive';
import { DerivationType } from '.';
import { bytesToHex } from '@stacks/common';
export const generateSecretKey = (entropy = 256) => {
    const secretKey = generateMnemonic(wordlist, entropy);
    return secretKey;
};
export const generateWallet = async ({ secretKey, password, }) => {
    const ciphertextBytes = await encrypt(secretKey, password);
    const encryptedSecretKey = bytesToHex(ciphertextBytes);
    const rootPrivateKey = await mnemonicToSeed(secretKey);
    const rootNode = HDKey.fromMasterSeed(rootPrivateKey);
    const walletKeys = await deriveWalletKeys(rootNode);
    const wallet = {
        ...walletKeys,
        encryptedSecretKey,
        accounts: [],
        config: {
            accounts: [],
        },
    };
    return generateNewAccount(wallet);
};
export const generateNewAccount = (wallet) => {
    const accountIndex = wallet.accounts.length;
    const newAccount = deriveAccount({
        rootNode: getRootNode(wallet),
        index: accountIndex,
        salt: wallet.salt,
        stxDerivationType: DerivationType.Wallet,
    });
    return {
        ...wallet,
        accounts: [...wallet.accounts, newAccount],
    };
};
//# sourceMappingURL=generate.js.map